// src/components/Header.js
import React, { useContext, useEffect, useState } from "react";
import "./Header.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { cfLogoutUrl, isProdHosted } from "../utils/cfAccess";

export default function Header() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // 홈 활성화: 이제 루트만 체크
  const isHome = pathname === "/";

  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (isHome) { setIsScrolled(false); return; }
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHome]);

  const onLogout = () => {
    // 운영: CF Access 로그아웃 페이지로
    if (isProdHosted()) {
      window.location.href = cfLogoutUrl(window.location.origin);
      return;
    }
    // 로컬/개발: 앱 내 토큰 로그아웃 + /token 으로
    logout();
    navigate("/token", { replace: true });
  };

  const closeMenu = () => setMenuOpen(false);

  const fireResetStaff  = () => setTimeout(() => window.dispatchEvent(new Event("reset-staff-search")), 0);
  const fireResetEvents = () => setTimeout(() => window.dispatchEvent(new Event("reset-events-search")), 0);

  return (
    <header className={`site-header${(!isHome && isScrolled) ? " scrolled" : ""}`}>
      <nav className="nav">
        {/* 왼쪽 메뉴 */}
        <div className="nav-left desktop-menu">
          <NavLink to="/" className="nav-link nav-home">홈</NavLink>
          <NavLink to="/staff"  className="nav-link"  onClick={fireResetStaff}>직원</NavLink>
          <NavLink to="/events" className="nav-link"  onClick={fireResetEvents}>이벤트</NavLink>
        </div>

        {/* 오른쪽 */}
        <div className="nav-right">
          <button className="logout-btn desktop-only" onClick={onLogout}>로그아웃</button>

          <button
            className={`menu-toggle mobile-only${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen(v => !v)}
            aria-label="메뉴 열기/닫기"
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </nav>

      {/* 모바일 드로어 */}
      <div id="mobile-drawer" className={`nav-drawer mobile-only${menuOpen ? " open" : ""}`}>
        <NavLink to="/" className="nav-link nav-home" onClick={closeMenu}>홈</NavLink>
        <NavLink to="/staff" className="nav-link" onClick={() => { fireResetStaff(); closeMenu(); }}>직원</NavLink>
        <NavLink to="/events" className="nav-link" onClick={() => { fireResetEvents(); closeMenu(); }}>이벤트</NavLink>
        <button className="logout-btn drawer-logout" onClick={() => { closeMenu(); onLogout(); }}>
          로그아웃
        </button>
      </div>
    </header>
  );
}